// Copyright (c) 2021, Elicenciamento. All rights reserved.

import React, { createContext, useContext, useEffect, useState } from "react";
import { buildDebts } from "./service";

const DebtsContext = createContext({
  setDebtsData: () => {},
  setDebtsState: () => {},
  setRemoveTransfer: () => {},
  debtsData: {},
  debtsState: {},
});

const DebtsProvider = ({ children }) => {
  const [debtsData, setDebtsData] = useState(null);
  const [removeTransfer, setRemoveTransfer] = useState(null);
  const [debtsState, setDebtsState] = useState({
    data: undefined,
  });

  useEffect(() => {
    if (debtsData && !removeTransfer) {
      (async () => {
        const debts = buildDebts(debtsData, false);

        setDebtsState((prevState) => ({
          ...prevState,
          data: debtsData,
          debts,
          cartTotal: debts.totalAmount,
          cartTotalInCents: debts.totalAmountInCents,
          debtsCode: debtsData?.debitCode,
        }));
      })();
    }
  }, [debtsData, removeTransfer]);

  useEffect(() => {
    if (removeTransfer) {
      const debts = buildDebts(debtsData, removeTransfer);

      setDebtsState((prevState) => ({
        ...prevState,
        debts,
        cartTotal: debts.totalAmount,
        cartTotalInCents: debts.totalAmountInCents,
      }));
    }
  }, [debtsData, removeTransfer]);

  const value = {
    setDebtsData,
    debtsData,
    debtsState,
    setDebtsState,
    setRemoveTransfer,
  };

  return (
    <DebtsContext.Provider value={value}>{children}</DebtsContext.Provider>
  );
};

const useDebtsStore = () => useContext(DebtsContext);

export { DebtsProvider, useDebtsStore };
